<div class="wrapper">
  <header>
    <div class="page">
      <mat-paginator #history_paginator [length]="48900" [pageSize]="100" [hidePageSize]="true"
        (page)="handlePageEvent($event)" [disabled]="disable_history_pagination" [showFirstLastButtons]="true">
      </mat-paginator>
    </div>
  </header>
  <table class="table table-hover">
    <thead>
      <tr>
        <th scope="col">Date</th>
        <th scope="col">Request Type</th>
        <th scope="col">Arca Response</th>
        <th scope="col">Arca URL</th>
      </tr>
    </thead>
    <tbody *ngIf="arcaLogs.length > 0">
      <tr *ngFor="let log of arcaLogs" style="cursor: pointer;" (click)="getSelectedArcaResponse(log.arcaResponse)"
        data-bs-toggle="modal" data-bs-target="#openMainInfo">
        <td>{{log.executionDate | date: 'dd/MM/yy HH:mm'}}</td>
        <td>{{log.type}}</td>
        <td>{{log.arcaResponse}}</td>
        <td>{{log.arcaUrl}}</td>
      </tr>
    </tbody>
  </table>
</div>


<div class="modal fade" id="openMainInfo" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Info</h5>
        <button #closeAddModal type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- error: false
        errorCode: 0
        errorCodeString: "0"
        formUrl: "https://ipay.arca.am/payment/merchants/18537501_binding/payment_en.html?mdOrder=16b2be0b-2cea-47b7-8d59-094d01b70b66"
        orderId: "16b2be0b-2cea-47b7-8d59-094d01b70b66" -->
        <div class="bl" *ngIf="selectedArcaResponse?.orderId">
          <div class="name">
            Order Id:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.orderId}}
            </span>
          </div>
        </div>

        <div class="bl" *ngIf="selectedArcaResponse?.error">
          <div class="name">
            Error:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.error}}
            </span>
          </div>
        </div>

        <div class="bl" *ngIf="selectedArcaResponse?.errorCode">
          <div class="name">
            Error Code:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.errorCode}}
            </span>
          </div>
        </div>

        <div class="bl" *ngIf="selectedArcaResponse?.errorCodeString">
          <div class="name">
            Error Code String:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.errorCodeString}}
            </span>
          </div>
        </div>

        <div class="bl" *ngIf="selectedArcaResponse?.formUrl">
          <div class="name">
            Form Url:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.formUrl}}
            </span>
          </div>
        </div>
        <!--  -->
        <div class="bl" *ngIf="selectedArcaResponse?.bankInfo">
          <div class="name">
            Bank Info:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.bankInfo?.bankName}}
            </span>
          </div>
        </div>

        <div class="bl" *ngIf="selectedArcaResponse?.cardAuthInfo">
          <div class="name">
            Card pan:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.cardAuthInfo?.pan}}
            </span>
          </div>
        </div>

        <div class="bl" *ngIf="selectedArcaResponse?.ip">
          <div class="name">
            Ip:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.ip}}
            </span>
          </div>
        </div>

        <div class="bl" *ngIf="selectedArcaResponse?.orderDescription">
          <div class="name">
            Order Description:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.orderDescription}}
            </span>
          </div>
        </div>

        <div class="bl" *ngIf="selectedArcaResponse?.orderNumber">
          <div class="name">
            Order Number:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.orderNumber}}
            </span>
          </div>
        </div>

        <div class="bl" *ngIf="selectedArcaResponse?.orderStatus">
          <div class="name">
            Order Status:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.orderStatus}}
            </span>
          </div>
        </div>


        <div class="bl" *ngIf="selectedArcaResponse?.paymentAmountInfo">
          <div class="name">
            Approved Amount:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.paymentAmountInfo.approvedAmount}}
            </span>
          </div>
        </div>
        <div class="bl" *ngIf="selectedArcaResponse?.paymentAmountInfo">
          <div class="name">
            Deposited Amount:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.paymentAmountInfo.depositedAmount}}
            </span>
          </div>
        </div>
        <div class="bl" *ngIf="selectedArcaResponse?.paymentAmountInfo">
          <div class="name">
            Payment State:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.paymentAmountInfo.paymentState}}
            </span>
          </div>
        </div>
        <div class="bl" *ngIf="selectedArcaResponse?.refundedAmount">
          <div class="name">
            Refunded Amount:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.paymentAmountInfo.refundedAmount}}
            </span>
          </div>
        </div>

        <div class="bl" *ngIf="selectedArcaResponse?.terminalId">
          <div class="name">
            Terminal Id:&nbsp;
          </div>
          <div class="data">
            <span>
              {{selectedArcaResponse?.terminalId}}
            </span>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id='closeAddModal'
          (clicl)="close()">Cancel</button>
      </div>
    </div>
  </div>
</div>